import { List, ListItem, ListItemText } from '@mui/material';
import { ExternalFeatureLayer } from '../../../mapping/mapping.types';

type OrganizationLayerListProps = {
  layers: ExternalFeatureLayer[];
};

export const OrganizationLayersList = ({
  layers,
}: OrganizationLayerListProps): JSX.Element => {
  return (
    <List>
      {layers.map((item) => (
        <ListItem key={item.mapLayerId} divider disablePadding>
          <ListItemText primary={item.displayName} sx={{ px: 2 }} />
        </ListItem>
      ))}
    </List>
  );
};
